export const INIT_UPLOADED_PK = 'INIT_UPLOADED_PK';

export function initUploadedPK(uploadedPK){
    return{
        type: INIT_UPLOADED_PK,
        mainState: {
            uploadedPK: uploadedPK
        }
    }
}